<div class="row">
    <div class="col-4">
        <div class="card card-info card-outline">
            <div class="card-header">
                <h3 class="card-title text-primary"><i class="fas fa-user-plus"></i> เพิ่ม/แก้ไข ข้อมูลพนักงาน</h3>
                <div class="card-tools text-primary ">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i>
                  </button>
                </div>
            </div>
            <div class="card-body">
                <!-- form เพิ่มข้อมูลพนักงาน -->
                <form #frm_addEmp="ngForm"
                    (ngSubmit)="saveAddEmp(frm_addEmp.value); resetFormAddemp()"novalidate>
                            <div class="form-group row">
                                <label for="dep_id" class="col-sm-2 col-form-label">แผนก</label>
                                <div class="col-sm-9">
                                    <input #dep_id ngModel name="dep_id" type="text" class="form-control" list="depdata" id="dep_id"
                                    required [ngClass]="{ 'is-invalid' : dep_id.invalid && (dep_id.dirty || dep_id.touched )}"
                                    [(ngModel)]="empEdit.dep_id">
                                    <datalist id="depdata">
                                        <option *ngFor="let item of departmentData" [value]="item.dep_id">
                                            {{item.dep_id}} {{item.dep_name}}
                                        </option>
                                    </datalist>
                                    <!-- <select #dep_id="ngModel" ngModel name="dep_id" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : dep_id.invalid && (dep_id.dirty || dep_id.touched )}">
                                        <option disabled>++เลือกแผนก++</option>
                                        <option *ngFor="let i of departmentData">{{ i.dep_name}}</option>
                                    </select> -->
                                    <!-- <div class="invalid-feedback">
                                        <span *ngIf="dep_id.hasError('required')">กรุณาเลือกแผนก</span>
                                    </div> -->
                                </div>
                                <div class="col-sm-1">
                                    <button (click)="departmentList()" type="button" class="btn btn-tool" data-toggle="tooltip" title="Refresh">
                                        <i class="	fas fa-circle-notch"></i></button>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="positionLevel" class="col-sm-2 col-form-label">ระดับพนักงาน</label>
                                <div class="col-sm-10">
                                    <select #positionLevel="ngModel" ngModel name="positionLevel" class="form-control"
                                    [(ngModel)]="empEdit.positionLevel">
                                        <option disabled selected>++เลือก++</option>
                                        <option value="11">11-ปฏิบัติการ1</option>
                                        <option value="12">12-ปฏิบัติการ2</option>
                                        <option value="13">13-ปฏิบัติการ3</option>
                                        <option value="14">14-ปฏิบัติการ4</option>
                                        <option value="21">21-บริหารงาน1</option>
                                        <option value="22">22-บริหารงาน2</option>
                                        <option value="23">23-บริหารงาน3</option>
                                        <option value="24">24-บริหารงาน4</option>
                                        <option value="31">31-ผู้บริหาร1</option>
                                        <option value="32">32-ผู้บริหาร2</option>
                                        <option value="33">33-ผู้บริหาร3</option>
                                        <option value="34">34-ผู้บริหาร4</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        <span *ngIf="positionLevel.hasError('required')">กรุณาเลือกระดับพนักงาน</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="positionName" class="col-sm-2 col-form-label">ชื่อตำแหน่ง</label>
                                <div class="col-sm-9">
                                    <select #positionName="ngModel" ngModel name="positionName" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : positionName.invalid && (positionName.dirty || positionName.touched )}">
                                        <option disabled selected>++เลือกตำแหน่ง++</option>
                                        <option *ngFor="let i of jobtitleData">{{ i.jobName}}</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        <span *ngIf="positionName.hasError('required')">กรุณาเลือตำแหน่งงาน</span>
                                    </div>
                                </div>
                                <div class="col-sm-1">
                                    <button (click)="jobList()" type="button" class="btn btn-tool" data-toggle="tooltip" title="Refresh">
                                        <i class="	fas fa-circle-notch"></i></button>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="tname" class="col-sm-2 col-form-label">คำนำหน้า</label>
                                <div class="col-sm-10">
                                    <select #tname="ngModel" ngModel name="tname" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : tname.invalid && (tname.dirty || tname.touched )}"
                                    [(ngModel)]="empEdit.tname">
                                        <option disabled selected>++เลือก++</option>
                                        <option>นาย</option>
                                        <option>นาง</option>
                                        <option>นางสาว</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        <span *ngIf="tname.hasError('required')">กรุณาเลือกคำนำหน้า</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="fname" class="col-sm-2 col-form-label">ชื่อ</label>
                                <div class="col-sm-10">
                                    <input type="text" #fname="ngModel" ngModel name="fname" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : fname.invalid && (fname.dirty || fname.touched )}"
                                    [(ngModel)]="empEdit.fname">
                                    <div class="invalid-feedback">
                                        <span *ngIf="fname.hasError('required')">กรุณาป้อนชื่อ</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="sname" class="col-sm-2 col-form-label">นามสกุล</label>
                                <div class="col-sm-10">
                                    <input type="text" #sname="ngModel" ngModel name="sname" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : sname.invalid && (sname.dirty || sname.touched )}"
                                    [(ngModel)]="empEdit.sname">
                                    <div class="invalid-feedback">
                                        <span *ngIf="sname.hasError('required')">กรุณาป้อนนามสกุล</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="nickname" class="col-sm-2 col-form-label">ชื่อเล่น</label>
                                <div class="col-sm-10">
                                    <input type="text" #nickname="ngModel" ngModel name="nickname" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : nickname.invalid && (nickname.dirty || nickname.touched )}"
                                    [(ngModel)]="empEdit.nickname">
                                    <div class="invalid-feedback">
                                        <span *ngIf="nickname.hasError('required')">กรุณาป้อนชื่อเล่น</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="idcard" class="col-sm-2 col-form-label">เลขบัตรประชาชน</label>
                                <div class="col-sm-10">
                                    <input type="text" #idcard="ngModel" ngModel name="idcard" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : idcard.invalid && (idcard.dirty || idcard.touched )}"
                                    minlength="13" maxlength="13" (keypress)="numberOnly($event)"
                                    [(ngModel)]="empEdit.idcard">
                                    <div class="invalid-feedback">
                                        <span *ngIf="idcard.hasError('required')">กรุณาป้อนเลขบัตรประชาชน</span>
                                        <span *ngIf="idcard.hasError('minlength')">เลขบัตรประชาชนต้อง13หลัก</span>
                                        <span *ngIf="idcard.hasError('maxlength')">เลขบัตรประชาชนต้อง13หลัก</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="emp_code" class="col-sm-2 col-form-label">รหัสพนักงาน</label>
                                <div class="col-sm-10">
                                    <input type="text" #emp_code="ngModel" ngModel name="emp_code" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : emp_code.invalid && (emp_code.dirty || emp_code.touched )}"
                                    minlength="5" maxlength="5" (keypress)="numberOnly($event)"
                                    [(ngModel)]="empEdit.emp_code">
                                    <div class="invalid-feedback">
                                        <span *ngIf="emp_code.hasError('required')">กรุณาป้อนรหัสพนักงาน5หลัก</span>
                                        <span *ngIf="emp_code.hasError('minlength')">กรุณาป้อนรหัสพนักงาน5หลัก</span>
                                        <span *ngIf="emp_code.hasError('maxlength')">กรุณาป้อนรหัสพนักงาน5หลัก</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="supcode" class="col-sm-2 col-form-label">รหัสนักส่งเสริม</label>
                                <div class="col-sm-10">
                                    <input type="text" #supcode="ngModel" ngModel name="supcode" class="form-control"
                                    [(ngModel)]="empEdit.supcode">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="emp_type" class="col-sm-2 col-form-label">ประเภทพนักงาน</label>
                                <div class="col-sm-10">
                                    <select #emp_type="ngModel" ngModel name="emp_type" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : emp_type.invalid && (emp_type.dirty || emp_type.touched )}"
                                    [(ngModel)]="empEdit.emp_type">
                                        <option disabled selected>++เลือก++</option>
                                        <option value="1">รายเดือน</option>
                                        <option value="2">รายวัน</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        <span *ngIf="emp_type.hasError('required')">กรุณาเลือกประเภทพนักงาน</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="birthday" class="col-sm-2 col-form-label">วันเกิด</label>
                                <div class="col-sm-10">
                                    <input type="date" #birthday="ngModel" ngModel name="birthday" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : birthday.invalid && (birthday.dirty || birthday.touched )}"
                                    [(ngModel)]="empEdit.birthday">
                                    <div class="invalid-feedback">
                                        <span *ngIf="birthday.hasError('required')">กรุณาเลือกวันเดือนปีเกิด</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="contact" class="col-sm-2 col-form-label">ที่ติดต่อ</label>
                                <div class="col-sm-10">
                                    <input type="text" #contact="ngModel" ngModel name="contact" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : contact.invalid && (contact.dirty || contact.touched )}"
                                    [(ngModel)]="empEdit.contact">
                                    <div class="invalid-feedback">
                                        <span *ngIf="contact.hasError('required')">กรุณาป้อนที่ติดต่อ</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="phone" class="col-sm-2 col-form-label">เบอร์ติดต่อ</label>
                                <div class="col-sm-10">
                                    <input type="text" #phone="ngModel" ngModel name="phone" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : phone.invalid && (phone.dirty || phone.touched )}"
                                    minlength="10" [(ngModel)]="empEdit.phone">
                                    <div class="invalid-feedback">
                                        <span *ngIf="phone.hasError('required')">กรุณาป้อนเบอร์ติดต่อ10หลัก</span>
                                        <span *ngIf="phone.hasError('minlength')">กรุณาป้อนเบอร์ติดต่อ10หลัก</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="lineid" class="col-sm-2 col-form-label">Line id</label>
                                <div class="col-sm-10">
                                    <input type="text" #lineid="ngModel" ngModel name="lineid" class="form-control"
                                    [(ngModel)]="empEdit.lineid">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="faceid" class="col-sm-2 col-form-label">facebook id</label>
                                <div class="col-sm-10">
                                    <input type="text" #faceid="ngModel" ngModel name="faceid" class="form-control"
                                    [(ngModel)]="empEdit.faceid">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="email" class="col-sm-2 col-form-label">email</label>
                                <div class="col-sm-10">
                                    <input type="text" #email="ngModel" ngModel name="email" class="form-control"
                                    [(ngModel)]="empEdit.email">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="dateStartBRR" class="col-sm-2 col-form-label">วันเริ่มงาน BRR</label>
                                <div class="col-sm-10">
                                    <input type="date" #dateStartBRR="ngModel" ngModel name="dateStartBRR" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : dateStartBRR.invalid && (dateStartBRR.dirty || dateStartBRR.touched )}"
                                    [(ngModel)]="empEdit.dateStartBRR">
                                    <div class="invalid-feedback">
                                        <span *ngIf="dateStartBRR.hasError('required')">กรุณาเลือกวันเริ่มทำงานBRR</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="dateStartBRD" class="col-sm-2 col-form-label">วันเริ่มงาน BRD</label>
                                <div class="col-sm-10">
                                    <input type="date" #dateStartBRD="ngModel" ngModel name="dateStartBRD" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : dateStartBRD.invalid && (dateStartBRD.dirty || dateStartBRD.touched )}"
                                    [(ngModel)]="empEdit.dateStartBRD">
                                    <div class="invalid-feedback">
                                        <span *ngIf="dateStartBRD.hasError('required')">กรุณาเลือกวันเริ่มทำงานBRD</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="education" class="col-sm-2 col-form-label">การศึกษา</label>
                                <div class="col-sm-10">
                                    <select #education="ngModel" ngModel name="education" class="form-control"
                                    required [ngClass]="{ 'is-invalid' : education.invalid && (education.dirty || education.touched )}"
                                    [(ngModel)]="empEdit.education">
                                        <option disabled selected>++เลือก++</option>
                                        <option value="1">ประถมศึกษา</option>
                                        <option value="2">มัธยมศึกษา</option>
                                        <option value="3">ปวช</option>
                                        <option value="4">ปวส</option>
                                        <option value="5">ปวท</option>
                                        <option value="6">ปริญญาตรี</option>
                                        <option value="7">ปริญญาโท</option>
                                        <option value="8">ปริญญาเอก</option>
                                        <option value="99">ไม่มีวุฒิการศึกษา</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        <span *ngIf="education.hasError('required')">กรุณาเลือกการศึกษา</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="input-group mb-3">
                                    <input #filepic_source="ngModel" ngModel name="filepic_source" type="file"
                                    class="form-control" (change)="selectFile($event)">
                                    <button class="btn btn-warning" [disabled]="!selectedFiles" (click)="upload()">
                                    <i class="	fas fa-cloud-upload-alt"> อัพโหลด</i>
                                    </button>
                                </div>
                                <div *ngIf="currentFileUpload" class="progress mt-2 mb-2">
                                    <div class="progress-bar progress-bar-info" role="progressbar"
                                      attr.aria-valuenow="{{ percentage }}" aria-valuemin="0" aria-valuemax="100"
                                      [ngStyle]="{ width: percentage + '%' }">
                                      {{ percentage }}%
                                    </div>
                                  </div>
                            </div>
                            <div class="form-group row">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">imgUrl</span>
                                    </div>
                                    <input type="text" #imgurl="ngModel" ngModel name="imgurl" [(ngModel)]="urlImg"
                                      class="form-control" readonly [(ngModel)]="empEdit.imgurl">
                                  </div>
                            </div>
                            <div class="form-group row">
                                <label for="remark" class="col-sm-2 col-form-label">บันทึก/หมายเหตุ</label>
                                <div class="col-sm-10">
                                    <input type="text" #remark="ngModel" ngModel name="remark" class="form-control"
                                    [(ngModel)]="empEdit.remark">
                                </div>
                            </div>
                            <input type="hidden" #dataid ngModel name ="dataid" [(ngModel)]="empEdit.dataid">
                    <div class="card-footer">
                        <button type="submit" class="btn btn-info" 
                            [disabled]="frm_addEmp.invalid">เพิ่มข้อมูล</button>
                        <button (click)="saveEditEmp(frm_addEmp.value)" 
                            type="button" class="btn btn-warning ml-1" 
                            *ngIf="formEdit">แก้ไขข้อมูล</button>
                        <button (click)="delEmp(dataid.value)" 
                            type="button" class="btn btn-danger ml-1" 
                            *ngIf="formEdit">ลบข้อมูล</button>
                        <button (click)="resetFormAddemp()" type="reset" class="btn btn-default float-right">กรอกใหม่</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-8">

        <!-- <div class="row">
            <div *ngFor="let item of empData" class="column">
              <div class="card">
                <img src="{{ item.imgurl }}" alt="{{ item.empcode }}" style="width:100%">
                <div class="container">
                  <h2>{{ item.tname.trim() }}{{ item.fname.trim() }}  {{ item.sname.trim() }}</h2>
                  <p class="title">แผนก &amp; {{ item.dep_name }}</p>
                  <p>ส่วน {{ item.parcode_doc }}</p>
                  <p>ผ่าย {{ item.faction_name }}</p>
                  <p><button class="button">Contact</button></p>
                </div>
              </div>
            </div>
          </div> -->

        <div class="card card-primary card-outline">
            <div class="card-header">
                <h3 class="card-title text-primary"><i class="fas fa-users"></i> ข้อมูลพนักงาน</h3>
                <button (click)="empList()" type="button" class="btn btn-link" data-toggle="tooltip" title="Refresh">
                    <i class="fa fa-rotate-right"></i></button>
                <div class="card-tools">
                    <!-- <span data-toggle="tooltip" title="3 New Messages" class="badge bg-primary">3</span> -->
                    <button (click)="empList()" type="button" class="btn btn-tool" data-toggle="tooltip" title="Refresh">
                        <i class="	fas fa-circle-notch"></i></button>
                    <button (click)="exportEmp()" type="button" class="btn btn-tool" data-toggle="tooltip" title="Download Excel">
                            <i class="	fas fa-file-excel"></i></button>
                    <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i>
                    </button>
                </div>
            </div>
            <div class="card-body table-responsive p-2" style="height: 400px">
                <table #tb_data class="table table-hover table-head-fixed text-nowrap" id="emp-table">
                    <thead>
                        <tr class="text-primary">
                            <th><i class="fas fa-user"></i></th>
                            <th>รหัสพนักงาน</th>
                            <th>รหัสนักส่งเสริม</th>
                            <th>ชื่อ</th>
                            <th>แผนก</th>
                            <th>ส่วน</th>
                            <th>ฝ่าย</th>
                            <th class="text-center"><i class="fas fa-bars"></i></th>
                        </tr>
                    </thead>
                    <tbody class="align-middle">
                        <tr (click)="editEmp(item.dataid)" *ngFor="let item of empData">
                            <td>
                                <img id="myImg" src="{{ item.imgurl }}" alt="emp" 
                                class="img-thumbnail responsive"
                                (click)="openModalEmp(item.dataid,item.imgurl)">
                            </td>
                            <td >{{ item.emp_code }}</td>
                            <td>{{ item.supcode }}</td>
                            <td>{{ item.tname.trim() }}{{ item.fname.trim() }}  {{ item.sname.trim() }}</td>
                            <td>{{ item.dep_name }}</td>
                            <td>{{ item.parcode_doc }}</td>
                            <td>{{ item.faction_name }}</td>
                            <!-- <td [ngClass]="[ item.schedule==1 && item.status_sv !=5 ? 'bg-warning align-middle' : 'align-middle' ]">{{ item.date_schedule | adtob }}</td> -->
                            <td class="text-center text-primary align-middle">
                                <a (click)="modalUpdataaudit(item.dataid)" data-bs-toggle="modal"
                                    data-bs-target="#explan_plant">
                                    <i class="fas fa-edit"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<!-- {{ frm_addEmp.value | json }} -->

<!-- The Modal แสดงรูปพนักงาน -->
<div class="modal" id="md_empPic">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <!-- <div class="modal-header">
          <h4 class="modal-title">Modal Heading</h4>
          <button (click)="closModalEmp()" type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div> -->
        <div class="modal-body">
            <img src="{{ imgInModal }}" alt="emp">
        </div>
        <div class="modal-footer">
          <button (click)="closModalEmp()" type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
</div>
  